import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { NavService } from '../../service/nav.service';
import { KeycloakService } from "keycloak-angular";
import { UserService } from "../../../public/onboarding/services/user.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalEmailComponent } from '../modal-email/modal-email.component';
import { ToastrService } from 'ngx-toastr';
import { environment } from "../../../../environments/environment";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public rightSidebar: boolean = false;
  public open: boolean = false;
  public openNav: boolean = false;
  public roleName: string = '';
  public userEmail: string = '';
  public helpUrl: string = '';
  public validated: [''];
  public isMobile: boolean;
  public isMobileList: boolean;
  public hideManual = false;
  public identificationDataRouterLink: string;

  @Output() rightSidebarEvent = new EventEmitter<boolean>();

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = window.innerWidth <= 991;
    this.isMobileList = window.innerWidth <= 1200;
  }

  constructor(
    public navServices: NavService,
    private keycloakService: KeycloakService,
    protected userService: UserService,
    private modalService: NgbModal,
    private toastrService: ToastrService,
  ) {
    this.isMobile = window.innerWidth <= 991;
    this.isMobileList = window.innerWidth <= 1200;
  }

  collapseSidebar(): void {
    this.open = !this.open;
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  closeSidebar(): void {
    this.open = false;
    this.navServices.collapseSidebar = true;
  }

  rightSideBar(): void {
    this.rightSidebar = !this.rightSidebar;
    this.rightSidebarEvent.emit(this.rightSidebar);
  }

  openMobileNav(): void {
    this.openNav = !this.openNav;
  }

  openEmailModal(): void {
    if (this.roleName === 'CLIENT FINAL') {
      const modalRef = this.modalService.open(ModalEmailComponent, { size: 'lg' });
      modalRef.result.then((result) => {
        if (result === 'success') {
          this.toastrService.success('Mailul a fost trimis cu success');
        }
      }, (reason) => {
      });
    } else if (this.roleName === 'OPERATOR DE RETEA' || this.roleName === 'FURNIZOR') {
      window.open('https://suport.posf.ro/otrs/', '_blank');
    }
  }

  ngOnInit(): void {
    const userRoles = this.keycloakService.getUserRoles();
    if (userRoles.indexOf('operator') > -1) {
      this.roleName = 'OPERATOR DE RETEA';
      this.identificationDataRouterLink = '/operator/date-identificare';
      this.helpUrl = '../../../../assets/pdf/POSF.ANRE - Manual de utilizare_Operator.docx';
    } else if (userRoles.indexOf('supplier') > -1) {
      this.roleName = 'FURNIZOR';
      this.identificationDataRouterLink = '/furnizor/date-identificare';
      this.helpUrl = '../../../../assets/pdf/POSF.ANRE - Manual de utilizare_Furnizor.docx';
    } else if (userRoles.indexOf('anre') > -1) {
      this.roleName = 'ANRE';
      this.helpUrl = '../../../../assets/pdf/POSF.ANRE - Manual de utilizare_ANRE.docx';
    } else {
      this.hideManual = true;
      this.roleName = 'CLIENT FINAL';
      this.identificationDataRouterLink = '/utilizator/persoana-fizica/date-identificare';
      // this.helpUrl = '../../../../assets/pdf/POSF.ANRE - Manual de utilizare_CF.docx';
    }
    this.loadProfile().then(user => {
      this.userEmail = user.username;
    });
    this.validated = JSON.parse(localStorage.getItem('validatedAndAdminRoleAssigned'));
  }

  loadProfile(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.keycloakService.isLoggedIn()) {
        this.keycloakService.loadUserProfile()
          .then(data => resolve(data))
          .catch(error => console.log(error));
      } else {
        console.log('user not logged in');
      }
    });
  }

  logout(): void {
    localStorage.clear();
    //var logoutOptions = "{ redirectUri : 'https://posf-staging.anre.ro/' }";
    this.keycloakService.logout(environment.feUrl).then(() => {
      // this.keycloakService.login();
      this.userService.clearCachedUserProfile();
    });
  }
}
